import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'

// 全局时区：巴西利亚 America/Sao_Paulo (UTC-3)
// 任何不带显式时区的 moment() 调用都按巴西利亚时间处理
// timezone.js 内部已调用 moment.tz.setDefault(BRT_TZ)，并提供统一工具函数
import moment from 'moment-timezone'
import {
  BRT_TZ,
  brtMoment,
  getBrtNow,
  toBrtISOString,
  toBrtDate,
  toBrtDateTime,
  daysBetween,
  getBrtDisplay,
  formatBrtDate,
  formatBrtDateTime,
  formatBrtApiDate,
  getBrtCurrentDate,
  getBrtDateString
} from './utils/timezone'

// 确保 moment 全局默认时区设置（与 timezone.js 保持一致）
moment.tz.setDefault(BRT_TZ)

// 将时区工具函数挂载到 Vue 原型，所有组件可通过 this 直接访问
Vue.prototype.$moment = moment
Vue.prototype.$BRT_TZ = BRT_TZ
Vue.prototype.$brtMoment = brtMoment
Vue.prototype.$getBrtNow = getBrtNow
Vue.prototype.$toBrtISOString = toBrtISOString
Vue.prototype.$toBrtDate = toBrtDate
Vue.prototype.$toBrtDateTime = toBrtDateTime
Vue.prototype.$daysBetween = daysBetween
Vue.prototype.$getBrtDisplay = getBrtDisplay
Vue.prototype.$formatBrtDate = formatBrtDate
Vue.prototype.$formatBrtDateTime = formatBrtDateTime
Vue.prototype.$formatBrtApiDate = formatBrtApiDate
Vue.prototype.$getBrtCurrentDate = getBrtCurrentDate
Vue.prototype.$getBrtDateString = getBrtDateString

import './plugins/tdesign'
import './assets/styles/global.css'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { initElementLocale } from './utils/elementLocale'

Vue.use(ElementUI)

initElementLocale(i18n.locale)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
